import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const useStyles = makeStyles((theme) => ({
  dropzoneBox: {
    //width: '300px',
    //height: '240px',
    border: '1px solid lightgray',
    // marginTop: theme.spacing(2),
    display: 'flex',
    //alignContent: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}));

const UploadComponent = ({ formik }) => {
  const classes = useStyles();

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => onDropHandler(files),
    multiple: false,
    maxSize: 1000000000,
  });


  const files = acceptedFiles.map((file, index) => (
    <Typography key={file.path} variant="body2" gutterBottom>
      {file.path} - {file.size} bytes
    </Typography>
  ));

  const onDropHandler = (files) => {
    formik.setFieldValue('file', files[0]);
  };

  return (
    <>
      {/** DropZone */}
      {/* <div {...getRootProps({ className: classes.dropzoneBox })}>
        <input {...getInputProps()} />
        <div ></div>
        <div><AttachFileIcon fontSize="large" /></div>
      </div> */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          borderRadius: 1,
          border: 1,
          textAlign: 'center',
          color: 'text.secondary',
        }}
        {...getRootProps()}
      >
        <input {...getInputProps()} />
        <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
          여기에 파일을 드래그 앤 드롭하거나 클릭하여 파일을 선택하십시오.
          {(formik.values.file === '' || formik.values.file === null)?'': files}
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          <AttachFileIcon fontSize="large" />
        </Box>
      </Box>
    </>
  );
};

export default UploadComponent;
